import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueRecruitmentShowBottom } from '../../../types/recruitmentShow';
import { RecruitmentShowBottomItemFirst } from '../../molecules/recruitmentShowBottomItemFirst';
import { RecruitmentShowBottomItemThird } from '../../molecules/recruitmentShowBottomItemThird';
import { RecruitmentShowBottomItemTags } from '../../molecules/recruitmentShowBottomItemTags';
import { RecruitmentShowBottomItemOccupations } from '../../molecules/recruitmentShowBottomItemOccupations';
import { RecruitmentEntryButtonSpBottom } from '../../molecules/recruitmentEntryButtonSpBottom';

type Props = {
  recruitmentId: number;
  companyId: number;
  noimage: string;
  noIconImg: string;
  isUser: boolean;
  isStopped: boolean;
  dataCategory: DataCategory;
  dataValue: DataValueRecruitmentShowBottom;
  isCompany: boolean;
  connectedFlag: boolean;
  isScouted: boolean;
  messageBoxId: number | null;
  isShowMag: boolean;
  hideTopEntryButton?: boolean;
  handleRegisterModalOpen: () => void;
  handleClickEntry: () => void;
  isPreview: boolean;
  handlePreviewClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  noimage,
  noIconImg,
  isUser,
  isStopped,
  dataCategory,
  dataValue,
  isCompany,
  connectedFlag,
  isScouted,
  messageBoxId,
  isShowMag,
  hideTopEntryButton = false,
  handleRegisterModalOpen,
  handleClickEntry,
  isPreview,
  handlePreviewClick,
}) => {
  return (
    <>
      <div className="recruitment__show__bottom first">
        <div className="recruitment__show__bottom__wrapper">
          <RecruitmentShowBottomItemFirst
            title="この求人を見ている人におすすめ"
            noimage={noimage}
            recruitmentId={recruitmentId}
            isStopped={isStopped}
            dataCategory={dataCategory}
            dataValue={dataValue}
            isPreview={isPreview}
          />
          <RecruitmentShowBottomItemThird
            title="最近閲覧した求人"
            noimage={noimage}
            recruitmentId={recruitmentId}
            isStopped={isStopped}
            dataCategory={dataCategory}
            dataValue={dataValue}
            isPreview={isPreview}
          />
          <RecruitmentShowBottomItemTags
            title="タグから探す"
            recruitmentId={recruitmentId}
            isStopped={isStopped}
            dataCategory={dataCategory}
            dataValue={dataValue}
            isPreview={isPreview}
          />
          <RecruitmentShowBottomItemOccupations
            title="似た条件から探す"
            recruitmentId={recruitmentId}
            isStopped={isStopped}
            dataCategory={dataCategory}
            dataValue={dataValue}
            isPreview={isPreview}
          />
        </div>
      </div>
      <RecruitmentEntryButtonSpBottom
        companyId={companyId}
        recruitmentId={recruitmentId}
        isConnected={connectedFlag}
        messageBoxId={messageBoxId}
        isStopped={isStopped}
        isLoggedIn={isUser || isCompany}
        isCompany={isCompany}
        isScouted={isScouted}
        isShowMag={isShowMag}
        hideTopEntryButton={hideTopEntryButton}
        handleRegisterModalOpen={handleRegisterModalOpen}
        handleClickEntry={handleClickEntry}
        isPreview={isPreview}
        handlePreviewClick={handlePreviewClick}
      />
    </>
  );
};
